import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'

export const STARTER_CREDITS = 500
export const GROWTH_CREDITS = 1200

export const STARTER_LOW_CREDIT_THRESHOLD = STARTER_CREDITS * 0.1
export const GROWTH_LOW_CREDIT_THRESHOLD = GROWTH_CREDITS * 0.1

export const getPlanCredits = (planKey: PaymentPlanKey): number => {
  switch (planKey) {
    case PaymentPlanKey.BlazeAutopilotStarter:
      return STARTER_CREDITS
    case PaymentPlanKey.BlazeAutopilotGrowth:
      return GROWTH_CREDITS
    default:
      return 0
  }
}
